/* eslint-disable */
import { FIELD } from "@/data/constants";
import { COUNTRIES } from "@/data/countries";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "australianVisaTitle",
    label: "Australian visa"
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_visadvs_passport_number",
    label: "Passport number",
    fieldRequired: true,
    validation: { required: true, max: 14 },
    hint: "Enter all letters and numbers as they appear on your passport."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_visadvs_givenname",
    label: "First name",
    fieldRequired: true,
    validation: { required: true, max: 49 },
    hint: "Enter exactly as it appears on your passport."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_visadvs_middlename",
    label: "Middle name",
    hint: "Enter exactly as it appears on your passport.",
    validation: { max: 49 },
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_visadvs_surname",
    label: "Last name",
    fieldRequired: true,
    validation: { required: true, max: 49 },
    hint: "Enter exactly as it appears on your passport."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_visadvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.INPUT.DROPDOWN,
    name: "greenid_visadvs_country_of_issue",
    label: "Passport country of issue",
    fieldRequired: true,
    validation: { required: true },
    options: COUNTRIES
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_visadvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];